import { render, staticRenderFns } from "./use.vue?vue&type=template&id=effd13b4&scoped=true&"
import script from "./use.vue?vue&type=script&lang=js&"
export * from "./use.vue?vue&type=script&lang=js&"
import style0 from "./use.vue?vue&type=style&index=0&id=effd13b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effd13b4",
  null
  
)

export default component.exports